import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-a4-page-text-editor',
  templateUrl: './a4-page-text-editor.component.html',
  styleUrls: ['./a4-page-text-editor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => A4PageTextEditorComponent),
    }
  ]
})
export class A4PageTextEditorComponent implements ControlValueAccessor, OnDestroy {

  noteControl: FormControl = new FormControl();
  pageMargin = {
    left: 2.2,
    top: 1.5,
    right: 1.5,
    bottom: 1.5
  }

  @Input() editable: boolean = true;

  public preText: string = "Bei einem Internetzugang und oder Sprachzugang erfolgt die Bereitstellung an dem Hauseingangsverteiler der an das Gebäude mit dem Campusnetz verbindet. Der Internetzugang ist ein transparenter Zugang ohne Firewall oder Proxyfunktion. Für die Sicherheit ist der Kunde eigenverantwortlich. Sicherheitsfunktionen können als Zusatzleistungen gebucht werden.";

  public afterText: string = "Besonderheiten für den Sprachzugang zum Telekommunikationsnetz auf dem WISTA-Campus<br>- der Anschluss zum öffentlichen ISDN Netz des Ortsnetzes Berlin ist enthalten<br>- keine Gesprächsgebühren auf dem Campusnetz innerhalb 030-6392-xxxxx";

  private _subscriptions: Subscription[] = [];

  constructor() { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  public onTouched: () => void = () => { };

  registerOnChange(fn: any): void {
    this._subscriptions
      .push(
        this.noteControl
          .valueChanges
          .subscribe(fn)
      );
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.noteControl.disable() : this.noteControl.enable();
  }

  writeValue(val: any): void {
    val && this.noteControl.patchValue(val, { emitEvent: false });
  }

}
